// extracted by mini-css-extract-plugin
export default {"banner":"B3paa","logo":"Yag-j","text":"b8uja"};